const DEVANAGARI_DIGITS = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
/**
 * DESIGN_SYSTEM.md §3: "Numerals are a render-time locale choice, never a stored value
 * and never computed per component." This is the one shared function every component
 * calls — nobody hand-rolls digit substitution locally.
 *
 * Only touches ASCII digits 0-9; safe to run on a string that also contains punctuation
 * (dates, "Page 3 of 12", percentages).
 *
 * NEVER call this on a tracking code (`MW-2083-004582`) — §3 is explicit that tracking
 * codes are identifiers, not quantities, and must stay typeable/matchable exactly as
 * printed in either locale.
 */
export function localizeNumerals(input, locale) {
    const str = String(input);
    if (locale === 'en')
        return str;
    return str.replace(/[0-9]/g, (digit) => DEVANAGARI_DIGITS[Number(digit)]);
}
export function formatNumber(value, { locale, group = true }) {
    // Grouping convention (comma placement) is not specified by DESIGN_SYSTEM.md §3 — only
    // the digit script (Devanagari vs. Latin) is. Kept to the plain Western thousands
    // grouping here rather than guessing at a Nepali lakh/crore convention that would be
    // an invented default; §3 governs digit shape only. See ASSUMPTIONS.md note in this
    // package's report if that guess needs revisiting once a native reviewer weighs in.
    const formatted = group ? value.toLocaleString('en-US') : String(value);
    return localizeNumerals(formatted, locale);
}
//# sourceMappingURL=numerals.js.map